<template>
    <div class="sentence-merger">
        <div class="sentence-merger__button-wrap">
            <slot :open="open">
                <button
                    type="button"
                    class="button button--blank sentence-merger__button"
                    @click="open"
                >
                    <svg
                        width="18"
                        height="18"
                        viewBox="0 0 267 267"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill="#ff6b06"
                            d="M8.34348 0.00439453C12.9491 0.00439453 16.687 3.74228 16.687 8.34788V125.157H50.0609V83.4393C50.0609 80.0685 52.0967 77.0148 55.2172 75.7299C58.3043 74.445 61.9087 75.1459 64.3116 77.5321L114.373 127.593C117.627 130.847 117.627 136.137 114.373 139.391L64.3116 189.452C62.7097 191.054 60.5737 191.905 58.4044 191.905C57.3365 191.905 56.2351 191.688 55.2172 191.271C52.0967 189.986 50.0609 186.932 50.0609 183.561V141.844H16.687V258.653C16.687 263.258 12.9491 266.996 8.34348 266.996C3.73788 266.996 -5.71115e-06 263.258 -5.71115e-06 258.653V8.34788C-5.71115e-06 3.74228 3.73788 0.00439453 8.34348 0.00439453ZM66.7479 163.42L96.6677 133.5L66.7479 103.58V163.42Z"
                        />
                        <path
                            fill="#ff6b06"
                            d="M152.627 127.61L202.688 77.5319C205.075 75.1456 208.679 74.4448 211.783 75.7297C214.903 77.0146 216.939 80.0683 216.939 83.4391V125.157H250.313V8.34767C250.313 3.74206 254.051 0.00418091 258.657 0.00418091C263.262 0.00418091 267 3.74206 267 8.34767V258.652C267 263.258 263.262 266.996 258.657 266.996C254.051 266.996 250.313 263.258 250.313 258.652V141.843H216.939V183.561C216.939 186.932 214.903 189.985 211.783 191.27C210.765 191.687 209.664 191.904 208.596 191.904C206.426 191.904 204.29 191.053 202.688 189.468L152.627 139.407C149.373 136.153 149.373 130.863 152.627 127.61ZM200.252 163.42V103.58L170.332 133.5L200.252 163.42Z"
                        />
                    </svg>
                </button>
            </slot>
        </div>
        <portal v-if="showModal" to="modals">
            <ConfirmModal
                name="merge-sentences"
                modal-class="sentence-merger__modal"
                :ok-label="$t('editor.glueSentences.merge')"
                @confirmed="mergeSentences"
                @canceled="showModal = false"
            >
                <template #head>
                    <div class="modal__title">
                        {{ $t('editor.glueSentences.title') }}
                    </div>
                </template>
                <template #content>
                    <div class="sentence-merger__inner-modal">
                        <Spinner v-if="loading" class="spinner--opaque">{{ loadingText }}</Spinner>
                        <div class="sentence-merger__text">
                            {{ $t('editor.glueSentences.notice') }}
                            <br />
                            {{ $t('editor.glueSentences.newSentence') }}
                            <p class="sentence-merger__sentence">
                                {{ result }}
                            </p>
                        </div>
                        <p>
                            {{ $t('sentenceSplitter.warning') }}
                        </p>
                        <ErrorList :error="error" />
                    </div>
                </template>
            </ConfirmModal>
        </portal>
    </div>
</template>

<script>
import { ErrorList } from '@speechki-frontend/shared/ui/forms';
import { ConfirmModal } from '@speechki-frontend/shared/ui/modals';

import { fetchBookpart } from '../../api/bookpart';

import { mergeBookparts } from '../../services/mergeBookparts';

export default {
    name: 'SentenceMerger',
    components: {
        ConfirmModal,
        ErrorList,
    },

    inject: ['selector', 'registerWsHandler', 'removeWsHandler'],

    data() {
        return {
            showModal: false,
            loading: false,
            first: {
                raw_text: '',
            },
            second: {
                raw_text: '',
            },
            loadingText: '',
            error: null,
        };
    },
    computed: {
        result() {
            return `${this.first.raw_text} ${this.second.raw_text}`;
        },
    },
    methods: {
        open() {
            this.showModal = true;
            this.prepareSentences();
        },

        close() {
            this.showModal = false;
        },

        async fetchSentence(id) {
            if (!id) return;
            return fetchBookpart(id);
        },

        async prepareSentences() {
            if (this.selector.selection.length !== 2) return;
            this.loading = true;

            // selector should contain bookpart objects
            if (this.selector.sortedSelection.every((item) => !!item.bookpart)) {
                this.first = this.selector.sortedSelection[0].bookpart;
                this.second = this.selector.sortedSelection[1].bookpart;
            } else {
                await Promise.all([
                    this.fetchSentence(this.selector.sortedSelection[0].id).then((response) => {
                        this.first = response;
                    }),
                    this.fetchSentence(this.selector.sortedSelection[1].id).then((response) => {
                        this.second = response;
                    }),
                ]);
            }

            this.loading = false;
        },

        async mergeSentences() {
            this.loading = true;
            try {
                this.loadingText = this.$t('editor.glueSentences.state.generating');
                await mergeBookparts(this.first.id, this.second.id);

                this.selector.clear();
                this.selector.select({
                    id: this.first.id,
                });
                this.finish();
            } catch (e) {
                this.error = e;
                this.loading = false;
            }
        },

        finish() {
            this.loading = false;
            this.showModal = false;
            this.$emit('merge');
        },
    },
};
</script>

<style lang="scss" src="./SentenceMerger.scss"></style>
